import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon, Popup } from 'semantic-ui-react'
import { ThemeContext } from 'styled-components'
import { ADMIN_ROLE_SLUG, FARMER_ROLE_SLUG, OPERATIVE_ROLE_SLUG } from '~/Constants'
import { FolderType } from '~/api/services/cloudStorage'
import CustomIcon from '~/components/CustomIcon'
import { useAuth } from '~/routes/components/AuthProvider'

interface FoldersProps {
  handleEditFolder: (folder: FolderType) => void
  setDeleteFolder: (folder: FolderType) => void
  folders: FolderType[]
  setFolderId: (folderId: string) => void
  folderId: string
  column: string
  handleRect: (e: HTMLDivElement) => void
  newFolderFiles: FolderType[]
}

const Folders: React.FC<FoldersProps> = (props) => {
  const {
    handleEditFolder,
    setDeleteFolder,
    folders,
    setFolderId,
    folderId,
    column,
    handleRect,
    newFolderFiles
  } = props

  const { firstColor } = useContext(ThemeContext)
  const { t } = useTranslation()
  const { systemData: { logged: { roleSlug } } } = useAuth()

  const editingRole = (roleSlug === ADMIN_ROLE_SLUG) || (roleSlug === OPERATIVE_ROLE_SLUG)
  const farmerRole = roleSlug === FARMER_ROLE_SLUG

  function renderFolderActions(folder) {
    return <div onClick={(e) => e.preventDefault()} className='hoverAction' style={{ display: 'flex', alignItems: 'baseline' }}>
      <Popup
        content={t('Edit')}
        trigger={<CustomIcon onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          handleEditFolder(folder)
        }} name='pencil' />}
      />
      {folder.filesCount === 0 && <Popup
        content={t('Delete')}
        trigger={<CustomIcon onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setDeleteFolder(folder)
        }} name='trash' />}
      />}
    </div>
  }

  function renderFolderName(folder) {
    return <>
      <div className='fileName'>{folder.title}</div>
      <span id={folder.id}>({folder.filesCount})</span>
    </>
  }

  function renderNewFolder() {
    const newFilesFolderOpened = folderId === 'newFolder'
    const activeClass = newFilesFolderOpened ? 'active' : ''
    return <div
      className={`itemWrapper ${activeClass}`}
      key={'newFolder'}
      onClick={() => setFolderId('newFolder')}
    >
      <div className='item'>
        <div className='itemLeft'>
          <Icon
            style={{ position: 'absolute', left: 0, top: 3 }}
            color={'yellow'}
            name='star'
            size='small'
          />
          <Icon style={{ color: firstColor }} name={newFilesFolderOpened ? 'folder open' : 'folder'} size='large' />
          <div className='fileNameWrapper'>
            <div className='fileName'>{t('New files')}</div>
            <span id={'newFolder'}>({newFolderFiles.length})</span>
          </div>
        </div>
      </div>
    </div>
  }

  return <>
    {farmerRole && renderNewFolder()}
    {folders.map((folder, index) => {
      const folderOpened = folder.id === folderId
      const activeClass = folderOpened ? 'active' : ''
      return <div
        className={`itemWrapper ${activeClass}`}
        key={folder.id}
        onClick={() => setFolderId(folder.id)}
        ref={index === folders.length - 1 ? handleRect : null}
      >
        <div className='item'>
          <div className='itemLeft'>
            {column !== '' && <Icon
              style={{ color: firstColor }}
              name={column === 'created_at' ? 'sort content ascending' : 'sort alphabet ascending'}
              size='large'
            />}
            <Icon
              style={{ color: firstColor }}
              name={folderOpened ? 'folder open' : 'folder'}
              size='large'
            />
            <div className='fileNameWrapper'>
              {renderFolderName(folder)}
            </div>
          </div>
          {editingRole && renderFolderActions(folder)}
        </div>
      </div>
    })}
  </>
}
export default Folders